import { StreamProvider } from '@cds/betting-offer/add-ons';
import { EventModel } from '@frontend/sports/betting-offer/feature/model';

export enum VideoStreamStatus {
    Error,
    NotStarted,
    Started,
    NotEnoughMoney,
}

export class VideoStreamResult {
    url: string;
    status: VideoStreamStatus;
    performUserIdentifier?: string;
    performAccessToken?: string;

    constructor(errorType: VideoStreamStatus = VideoStreamStatus.Error) {
        this.status = errorType;
    }
}

export interface UnasResponse {
    data: {
        token: {
            _status: string;
            _url: string;
        };
    };
}

export interface ImgApiResponse {
    statusCode: number;
    hlsUrl: string;
}

export interface PerformV2Response {
    meta: {
        id: string;
        accessLevel: string;
    };
    sessionToken: string;
    launchInfo: {
        streamLauncher: StreamLauncher[];
    };
}

export interface StreamLauncher {
    playerAlias: string;
    launcherURL: string;
}

export interface PerformV2Attributes {
    url: string;
    baseUrl: string;
    providerEventId: string;
    outletKey: string;
    streamId?: string;
    userId?: string;
    accessToken?: string;
    language: string;
}

export interface VideoStreamError {
    bubbles: boolean;
    cancelBubble: boolean;
    cancelable: boolean;
    composed: boolean;
    currentTarget: XMLHttpRequest;
    defaultPrevented: boolean;
    eventPhase: number;
    isTrusted: boolean;
    lengthComputable: boolean;
    loaded: number;
    path: Array<string>;
    returnValue: boolean;
    srcElement: XMLHttpRequest;
    target: XMLHttpRequest;
    timeStamp: number;
    total: number;
    type: string;
    status: string;
}

export enum PlaySource {
    Overlay = 'Overlay',
    PlayPauseButton = 'PlayPauseButton',
}
export interface VideoDimension {
    height?: number;
    width?: number;
    transform?: number;
}

export interface VideoAttributes extends VideoDimension {
    pinnable: boolean;
}

export enum SelfExcludedCategories {
    Closed = 1,
    ClosedWithCoolOff = 2,
}

export enum HttpMethod {
    Get = 'Get',
    Post = 'Post',
}

export function showStreamingMessage(event: EventModel, hideWhenStarted?: boolean): boolean {
    const isTwitchEsport = !!event.sport.isEsport && event.stream?.provider === StreamProvider.Unikrn;

    if (!isTwitchEsport) {
        return false;
    }

    if (event.scoreboard.started) {
        if (!event.stream?.twitchChannel && !event.stream?.streamUrl) {
            return false;
        }

        return !hideWhenStarted;
    }

    return event.startDate.getTime() - Date.now() <= 60 * 60 * 1000;
}
